import {Component} from 'react';
import {loadModules} from 'esri-loader';


export default class Locate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            locate: null
        };
    }

    render() {
        return null;
    }

    onLocate = (geolocation) => {
        if(!this.state.locate){
            return;
        }
        if(!this.props.keepLoc && !this.state.locate.goToLocationEnabled){
            let location = this.state.locate;
            location.goToLocationEnabled = true;
            location.locate();
            this.setState({locate: location});
        }
        if(typeof this.props.scale === 'number') {
            geolocation.target.view.scale = this.props.scale;
        } else if(geolocation.target){
            geolocation.target.view.scale = 6000;
        }
        if (typeof this.props.onLocate === 'function') {
            this.props.onLocate(geolocation)
        }
    };

    componentDidMount() {
        loadModules(['esri/widgets/Locate']).then(([Locate]) => {

            let locate = new Locate({
                view: this.props.view,
                goToLocationEnabled: this.props.keepLoc ? false : true,
            });
            locate.on('locate', this.onLocate);

            this.setState({locate});

            this.props.view.ui.add(locate, 'top-left');
            locate.locate();
        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.ui.remove(this.state.locate);
    }
}
